import { Component, Input } from '@angular/core';

@Component({
    selector: 'data-analysis-value',
    templateUrl: 'data-analysis-value.component.html',
    styles: [
        `
            .delta {
                font-size: 10px;
                opacity: 0.7;
                white-space: nowrap;
            }

            .value {
                white-space: nowrap;
            }
        `,
    ],
})
export class TrainingDataAnalysisValueComponent {
    @Input()
    data: any;

    @Input()
    property: string;

    @Input()
    isAmount: boolean;

    constructor() {}

    value(data, property, isDelta = false, isAmount = false) {
        if (!data || !data.value || !property) {
            return '';
        }

        let value = 0;
        if (isDelta) {
            value = this.estimateDelta(data, property);
        } else {
            value = this.estimateValue(data, property);
        }
        return TrainingDataAnalysisValueComponent.formatValue(
            value,
            isAmount,
            isDelta
        );
    }

    private estimateValue(data, property) {
        const properties = property.split('.');
        return this.findValue(data.value.current, properties);
    }

    private estimateDelta(data, property) {
        const properties = property.split('.');

        const valueCurrent = this.findValue(data.value.current, properties);
        const valuePrevious = this.findValue(data.value.previous, properties);

        return valueCurrent - valuePrevious;
    }

    private findValue(data, properties) {
        let value = data;
        for (let i = 0; i < properties.length; i++) {
            const p = properties[i];
            if (!value || !value.hasOwnProperty(p)) {
                return 0;
            } else {
                value = value[p];
            }
        }
        return value;
    }

    private static formatAmount(value) {
        value /= 100;
        value = parseInt(value)
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+\.)/g, '$1,');

        function replaceAll(str, find, replace) {
            return str.replace(new RegExp(find, 'g'), replace);
        }

        value = replaceAll(value, ',', ' ');
        return replaceAll(value, '\\.', ',');
    }

    static formatValue(value, isAmount, isDelta, fixValue = false) {
        if (isDelta) {
            if (isAmount) {
                if (value > 0) {
                    return (
                        '+' +
                        TrainingDataAnalysisValueComponent.formatAmount(value)
                    );
                } else {
                    return (
                        '-' +
                        TrainingDataAnalysisValueComponent.formatAmount(
                            value * -1
                        )
                    );
                }
            } else {
                if (fixValue) {
                    if (value > 0) {
                        return '+' + value.toFixed(2);
                    } else {
                        return '-' + (value * -1).toFixed(2);
                    }
                } else {
                    if (value > 0) {
                        return '+' + value;
                    } else {
                        return '-' + value * -1;
                    }
                }
            }
        } else {
            if (isAmount) {
                return TrainingDataAnalysisValueComponent.formatAmount(value);
            } else {
                if (fixValue) {
                    return value.toFixed(2);
                } else {
                    return value;
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/stats/data-analysis/_component/data-analysis-value.component.ts